import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAuthToken } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setError("We didn't get a session id back from Google. Please try signing in again.");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id: sessionId });
        setAuthToken(data.token);
        try { localStorage.setItem("pgm_user", JSON.stringify(data.user)); } catch (e) { console.warn("Local cache write failed:", e); }
        setUser(data.user);
        // Clear the hash so the session_id never lingers in browser history
        window.history.replaceState(null, "", window.location.pathname);
        if (data.user.must_reset_password) nav("/change-password", { replace: true });
        else if (data.user.role === "super_admin") nav("/admin/platform", { replace: true });
        else nav("/dashboard", { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail;
        const status = e?.response?.status;
        if (status === 404) setError(detail || "No account found for that Google email yet. Request access from the landing page first.");
        else if (status === 401) setError(detail || "Your Google sign-in link expired. Please try again.");
        else if (status === 403) setError(detail || "Your account has been suspended. Contact your show owner.");
        else setError(detail || "Sign-in failed. Please try again.");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="pgm-login-bg">
      <div className="pgm-card pgm-reveal" style={{ maxWidth: 460 }}>
        <div className="pgm-micro">◆ Signing you in</div>
        <h2 className="pgm-display" style={{ fontSize: 26, marginTop: 4 }}>
          {error ? "Couldn't sign you in" : "Connecting to your account…"}
        </h2>
        {error ? (
          <div>
            <div className="pgm-callout" style={{ background: "var(--pgm-orange)", color: "var(--pgm-cream)", marginTop: 12 }} data-testid="auth-callback-error">{error}</div>
            <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
              <button className="pgm-btn" onClick={() => nav("/login")} data-testid="auth-callback-back-login">Back to sign in</button>
              <button className="pgm-btn pgm-btn-ghost" onClick={() => nav("/")} data-testid="auth-callback-request">Request access</button>
            </div>
          </div>
        ) : (
          <p style={{ marginTop: 10, opacity: 0.8 }}>One moment…</p>
        )}
      </div>
    </div>
  );
}
